'use client';

import { useAuth } from '@/context/auth.context';
import { useAnswerTemplates } from '@/components/answer-templates/use-answer-templates';
import { ModalAnswerTemplatesEditorFromBindings } from '@/components/modal-answer-picked/ModalAnswerTemplatesEditor';
import { SettingsRefreshButtonsView } from '@/components/settings-refresh-buttons/SettingsRefreshButtonsView';
import { useSettingsRefreshButtonsController } from '@/components/settings-refresh-buttons/use-settings-refresh-buttons-controller';
import { useAutoRepliesModal } from '@/context/auto-replies-modal.context';

type SettingsRefreshButtonsProps = {
    controlsScope?: 'top' | 'bottom';
    selectedAutoRepliesRun?: {
        enabled: boolean;
        openSelectedAutoRepliesModal: () => void;
    };
};

const SettingsRefreshButtons = ({ controlsScope, selectedAutoRepliesRun }: SettingsRefreshButtonsProps) => {
    const { accessToken } = useAuth();
    const controller = useSettingsRefreshButtonsController();
    const { openAutoRepliesModal } = useAutoRepliesModal();
    const showAutoRepliesButton = controlsScope !== 'bottom';
    const showAnswerTemplatesButton = controlsScope !== 'bottom';
    const templatesBindings = useAnswerTemplates({
        isShown: showAnswerTemplatesButton,
        accessToken,
    });

    return (
        <div data-controls-group="settings-refresh-buttons" data-controls-scope={controlsScope}>
            <SettingsRefreshButtonsView
                openSettingsModal={controller.openSettingsModal}
                openAutoRepliesModal={openAutoRepliesModal}
                openSelectedAutoRepliesModal={selectedAutoRepliesRun?.openSelectedAutoRepliesModal}
                openAnswerTemplatesEditor={templatesBindings.onOpenTemplatesEditor}
                showAutoRepliesButton={showAutoRepliesButton}
                showAnswerTemplatesButton={showAnswerTemplatesButton}
                isSelectedAutoRepliesRunEnabled={selectedAutoRepliesRun?.enabled === true}
            />
            {showAnswerTemplatesButton && templatesBindings.isTemplatesEditorShown ? (
                <ModalAnswerTemplatesEditorFromBindings bindings={templatesBindings} />
            ) : null}
        </div>
    );
};

export default SettingsRefreshButtons;
